export default __webpack_public_path__ + "static/media/Astronaut-rafiki.8504e0fe.png";